import * as React from 'react';

export interface EnhancedTableContextType {
  items: any[];
  count: number;
  page: number;
  pageSize: number;
  isLoading: boolean;
  filterValues: Record<string, any>;
  sortDirection: 'asc' | 'desc';
  orderByField: string;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  refreshColumnsData: () => void;
  setFilterValues: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  handleRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  handleOnDelete: (id: number) => void;
}

const EnhancedTableContext = React.createContext<EnhancedTableContextType | null>(null);

interface ProviderProps {
  children: React.ReactNode;
  value: EnhancedTableContextType;
}

export const EnhancedTableProvider = ({ children, value }: ProviderProps) => {
  return <EnhancedTableContext.Provider value={value}>{children}</EnhancedTableContext.Provider>;
};

export const useEnhancedTableContext = () => {
  const context = React.useContext(EnhancedTableContext);
  if (!context) {
    throw new Error(
      "useEnhancedTableContext deve essere usato all'interno di un EnhancedTableProvider"
    );
  }
  return context;
};
